/**
 * Mixpanel Analytics
 * Only initializes in staging/production environments
 */

import mixpanel from "mixpanel-browser"

// Only initialize in staging/production
const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
  })
}

export const analytics = {
  /**
   * Track an event
   */
  track: (event: string, properties?: Record<string, unknown>) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.track(event, {
        ...properties,
        timestamp: new Date().toISOString(),
      })
    }
  },

  /**
   * Identify a user and set their profile
   */
  identify: (userId: string, traits?: Record<string, unknown>) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.identify(userId)
      if (traits) {
        mixpanel.people.set(traits)
      }
    }
  },

  /**
   * Set user profile properties
   * Used for profile creation, updates, and settings changes
   */
  setUserProfile: (properties: Record<string, unknown>) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.people.set(properties)
    }
  },

  /**
   * Reset user (on logout)
   */
  reset: () => {
    if (MIXPANEL_TOKEN) {
      mixpanel.reset()
    }
  },
}
